import React, { useState } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import Input from "../../components/common/Input";
// import { isEmpty } from "../../utils/utils";
import Button from "../../components/common/Button";
import { Auth } from "aws-amplify";
import Loading from "../../components/Loading/Loading";

const ReceiveCode = ({ handleOk, handleCancel }) => {
  const [localUser, setLocalUser] = useState("");
  const [localCode, setLocalCode] = useState("");
  const [localPassword, setLocalPassword] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [validationOk, setValidationOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLoading = (value) => setLoading(value);

  const clearValidation = () => {
    setValidationMessage("");
    setValidationOk(false);
  };

  const handleUserChange = (value) => {
    setLocalUser(value);
    clearValidation();
  };
  const handleCodeChange = (value) => {
    setLocalCode(value);
    clearValidation();
  };
  const handlePasswordChange = (value) => {
    setLocalPassword(value);
    clearValidation();
  };

  const handleCompleteReceptionCode = async (e) => {
    try {
      e.preventDefault();
      handleLoading(true);
      await Auth.forgotPasswordSubmit(localUser, localCode, localPassword);
      handleLoading(false);
      setValidationOk(true);
      setValidationMessage(
        "Se realizo el restablecimiento de contraseña correctamente"
      );
      handleOk();
    } catch (error) {
      handleLoading(false);
      setValidationOk(false);
      if ("UserNotConfirmedException" === error.code) {
        setValidationMessage(
          "Usuario requiere confirmación del registro antes de Loguear"
        );
      } else if ("PasswordResetRequiredException" === error.code) {
        setValidationMessage("Se requiere restablecer la contraseña");
      } else if ("NotAuthorizedException" === error.code) {
        setValidationMessage("Contraseña inválida");
      } else if ("UserNotFoundException" === error.code) {
        setValidationMessage("Usuario no existe");
      } else if ("InvalidPasswordException" === error.code) {
        setValidationMessage("El formato de contraseña es inválido.");
      } else if ("LimitExceededException" === error.code) {
        setValidationMessage(
          "Se ha excedido el límite de intentos, intente después de un tiempo."
        );
      } else {
        setValidationMessage(
          "Ocurrió un error al autenticar. Contacte al administrador"
        );
      }
    }
  };

  return (
    <form
      onSubmit={handleCompleteReceptionCode}
      className="codepassword-layout"
    >
      <>
        <p className="title-04">Hola!</p>
        <p className="title-07">
          Usted solicito restablecer su contraseña{" "}
          <b>Verificar Código en el correo registrado.</b> La nueva contraseña
          debe tener un tamaño mínimo de 8 caracteres. Además debe contener
          letras mayúsculas, minúsculas, números y caracteres especiales.
        </p>
        <Input
          label="Usuario"
          value={localUser}
          onChange={(newValue) => handleUserChange(newValue)}
        />
        <Input
          label="Codigo"
          value={localCode}
          onChange={(newValue) => handleCodeChange(newValue)}
        />
        <Input
          label="Contraseña"
          value={localPassword}
          onChange={(newValue) => handlePasswordChange(newValue)}
          minLength={8}
          maxLength={50}
          type="password"
        />
        {validationMessage && (
          <span className={validationOk ? "message-success" : "message-error"}>
            * {validationMessage}
          </span>
        )}
        <div className="codepassword-layout__btns d-flex w100">
          <div className="w40">
            <Button
              primary
              text="Actualizar contraseña"
              onClick={handleCompleteReceptionCode}
            />
          </div>
          <div className="w40">
            <Button secondary text="Cancelar" onClick={handleCancel} />
          </div>
        </div>
      </>
      {loading && <Loading />}
    </form>
  );
};

ReceiveCode.propTypes = {
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
};

ReceiveCode.defaultProps = {
  handleOk: null,
  handleCancel: null,
};

export default ReceiveCode;
